import { SEO } from "@/components/SEO";
import { Action } from "@/components/marketing/Marketing";
export default function AboutPage() {
  return (
    <div className="growth">
      <SEO
        title="About Better Systems AI"
        description="Meet Rodo Alvarez. Practical AI, automation, and business systems built around how your team works."
        url="https://www.bettersystems.ai/about"
      />
      <section className="hero">
        <div className="wrap split">
          <div>
            <span className="eyebrow">
              Built with the business owner in mind
            </span>
            <h1>
              Technology should
              <br />
              <em>make work easier.</em>
            </h1>
            <p className="intro">
              I’m Rodo Alvarez, founder of Better Systems AI. I work with
              business owners to turn scattered tools, repeated tasks, and
              missed follow-ups into systems their teams can use.
            </p>
            <p className="muted">
              Our work spans restaurants, service companies, wholesale
              operations, and compost yards. We start by understanding the
              business, then build the right combination of AI, automation, and
              custom software.
            </p>
            <div className="actions">
              <Action href="/contact">Tell me about your business</Action>
            </div>
          </div>
          <img
            className="portrait"
            src="/rodolfo-portrait.jpg"
            alt="Rodo Alvarez, founder of Better Systems AI"
          />
        </div>
      </section>
      <section className="section">
        <div className="wrap process">
          {[
            [
              "Useful first",
              "Start with a real problem and a clear outcome. Every tool should have a job.",
            ],
            [
              "Your team stays in control",
              "Define approvals, access, and exceptions. Automation should support the people responsible for the work.",
            ],
            [
              "Build, learn, improve",
              "Launch a focused workflow, see how people use it, and improve it with their feedback.",
            ],
          ].map(([t, b]) => (
            <div key={t}>
              <h3>{t}</h3>
              <p className="muted">{b}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
